<template>
  <div class="site">
    <common-layout>
      <div slot="header">
        <h3>特色服务</h3>
      </div>
      <div slot="container">
        <div class="base-search">
          <el-select
              v-model="listQuery.problemBelongs"
              placeholder="请选择问题类型"
              clearable
              style="display: block;width: 200px;margin-right: 20px"
              @change="searchSelect"
          >
            <el-option label="新闻动态" :value="1"></el-option>
            <el-option label="融资需求" :value="2"></el-option>
            <el-option label="投资机构" :value="3"></el-option>
            <el-option label="金融机构" :value="4"></el-option>
            <el-option label="科技项目库" :value="5"></el-option>
            <el-option label="金融专家" :value="6"></el-option>
            <el-option label="政策法规" :value="7"></el-option>
          </el-select>
          <el-select
              v-model="listQuery.problemBelongs"
              placeholder="请选择问题状态"
              clearable
              style="display: block;width: 200px;margin:0 20px"
              @change="searchSelect"
          >
            <el-option label="未解决" :value="0"></el-option>
            <el-option label="已解决" :value="1"></el-option>
          </el-select>
          <el-date-picker
              v-model="listQuery.time"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="请选择成立时间"
              style="text-align: left;width:360px;margin:0 20px"
              clearable
          ></el-date-picker>
        </div>

        <div class="base-table">
          <el-table
              ref="multipleTable"
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
              class="table"
          >
            <el-table-column
                type="index"
                :index="
                index => {
                  return index + (listQuery.page - 1) * listQuery.pageSize + 1;
                }
              "
                label="序号"
                align="center"
            ></el-table-column>
            <el-table-column label="问题所属模块" align="center" prop="problemBelongs">
              <template slot-scope="{row}">
                <span>{{problemTypeEnum[row.problemBelongs-1].value}}</span>
              </template>
            </el-table-column>
            <el-table-column label="问题描述" align="center" prop="descriptionProblem" min-width="200">
              <template slot-scope="{ row }">
                <el-tooltip placement="top">
                  <div style="width: 400px;" slot="content">{{row.descriptionProblem}}</div>
                  <div class="overflow-hidde">{{row.descriptionProblem}}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
                label="联系方式"
                align="center"
                prop="phone"
            ></el-table-column>
            <el-table-column
                label="发布时间"
                align="center"
                prop="createTime"
            ></el-table-column>
            <el-table-column label="问题状态" align="center" prop="status">
              <template slot-scope="{ row }">
                <el-tag type="danger" v-show="row.status === 0">未解决</el-tag>
                <el-tag type="success" v-show="row.status === 1">已解决</el-tag>
              </template>
            </el-table-column>
            <el-table-column
                label="问题处理人"
                align="center"
                prop="handlerName"
            ></el-table-column>

            <el-table-column width="240px" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                    class="mini_btn"
                    size="mini"
                    type="primary"
                    @click="handleEdit(scope.$index, scope.row)"
                >
                  编辑
                </el-button>
<!--                <el-button size="mini" type="danger" @click="handleDetail(scope.$index, scope.row)">-->
<!--                  详情-->
<!--                </el-button>-->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next,jumper"
            :total="total"
            :current-page.sync="listQuery.page"
            style="text-align:left;margin:20px 0"
            :page-size="listQuery.pageSize"
        ></el-pagination>
      </div>
    </common-layout>

    <el-dialog
        :visible.sync="dialogFormVisible"
        title="问题详情"
        :close-on-click-modal="false"
        :append-to-body="true"

    >
<!--      @open="open"-->
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px">
        <el-row>
          <el-row>
            <el-form-item label="问题所属模块" prop="problemBelongs">
              <el-select
                  v-model="ruleForm.problemBelongs"
                  placeholder="请选择问题所属模块"
                  clearable
                  style="display: block;"
                  disabled
              >
                <el-option
                    v-for="item in problemTypeEnum"
                    :label="item.value"
                    :value="item.id"
                    :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="问题截图" prop="imgUrl">
              <el-upload

                  class="avatar-uploader"
                  :action="this.uploadURL"
                  list-type="picture-card"
                  name="file"
                  :file-list="ruleForm.imgUrl"
                  :before-upload="beforeAvatarUpload"
                  disabled
                  :limit="limit"
                  ref="upload0"
                  :on-success="
                  (response, file, fileList) =>
                    handleAvatarSuccess(response, file, fileList, 'imgUrl')"
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                  <span class="el-upload-list__item-actions">
                    <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
<!--                    <span-->
<!--                        v-if="!isDetail"-->
<!--                        class="el-upload-list__item-delete"-->
<!--                        @click="handleRemove(file, 'imgUrl')"-->
<!--                    >-->
<!--                      <i class="el-icon-delete"></i>-->
<!--                    </span>-->
                  </span>
                </div>
                <div slot="tip" class="el-upload__tip" v-if="showUpload1 && !isDetail">
                  只允许上传一张图片
                </div>
              </el-upload>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="问题描述" prop="descriptionProblem">
              <el-input
                  type="textarea"
                  autosize
                  placeholder="请输入机构简介"
                  v-model="ruleForm.descriptionProblem"
                  disabled
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="联系方式" prop="phone">
              <el-input
                  v-model="ruleForm.phone"
                  placeholder="请输入联系方式"
                  disabled
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="问题状态" prop="status">
              <el-select
                  v-model="ruleForm.status"
                  placeholder="请选择问题状态"
                  clearable
                  style="display: block;"
              >
                <el-option
                    v-for="item in problemStatusList"
                    :label="item.label"
                    :value="item.value"
                    :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row v-show="ruleForm.status === 1 ">
            <el-form-item label="问题处理人" prop="checker_id" style="text-align: left">
              <el-select
                  v-model="ruleForm.handler"
                  placeholder="请选择"
                  style="width: 100%"
              >
<!--                @change="changeCheck()"-->
                <el-option
                    v-for="(item, index) in checkerOption"
                    :key="index"
                    :label="item.username"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
            type="primary"
            @click="editOperate"
            v-if="dialogType === 'edit' || dialogType === 'detail'">
          修 改
        </el-button>
        <el-button type="primary" @click="createSite" v-if="dialogType === 'add'">确 定</el-button>
        <el-button @click="dialogFormVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import CommonLayout from '../../../components/common-layout.vue';
export default {
  components: {
    CommonLayout
  },
  data() {
    return {
      checkerOption: [],
      problemTypeEnum:[
        { id: "1", value: '新闻动态' },
        { id: '2', value: '融资需求' },
        { id: '3', value: '投资机构' },
        { id: '4', value: '金融机构' },
        { id: '5', value: '金融产品' },
        { id: '6', value: '科技项目库' },
        { id: '7', value: '金融专家' },
        { id: '8', value: '法律法规' },
      ],
      // 问题状态
      problemStatusList:[
          {label:'未解决',value:0},
          {label:'已解决',value:1},
      ],
      Title: '',
      // 1待审核, 2不通过, 3退回, 4通过
      approvalStatus: '',
      formApprovalStatus: '',
      listQuery: {
        time:[],
        problemBelongs: '',
        page: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      dialogType: '',
      dialogImageUrl: '',
      logoSrc: [],
      realImageSrc: [],
      successCaseLogoSrc: [],
      is_edit: false,
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE'
      },
      orgTypeList: [],
      investmentList: [],
      number: 0,
      operationType: 'add',
      per_page: 10,
      total: 20,
      dialogFormVisible: false,
      ruleForm: {
        approvalStatus: 1,
        problemBelongs:'', // 问题所属模块
        imgUrl:[], // 图片地址
        descriptionProblem:'', // 问题描述
        phone:'', // 联系方式
        status:'', // 问题状态 0未处理 1已处理
        handler:'', // 处理人
        creator:'', // 创建人
        createTime:'', //创建时间/发布时间
        updater:'', //修改人
        updateTime:'', //修改时间
        deleted:'', //是否删除；非1 已删除',
      },
      rules: {

      },
      tableData: [],
      limit: 1,
      showUpload1: false,
      showUpload2: false
    };
  },
  computed: {
    isDetail() {
      return this.dialogType === 'detail';
      // return this.dialogType === 'detail' && this.formApprovalStatus === 4;
    }
  },
  created() {
    this.getData();
    this.getChecks()
    // this.getGroup();
  },
  watch: {
    // 监听初始时图片列表长度, 与limit相等则隐藏按钮
    logoSrc: {
      handler() {
        this.checkLimit(this.logoSrc, 0);
      }
    },
    realImageSrc: {
      handler() {
        this.checkLimit(this.realImageSrc, 1);
      }
    }
  },
  methods: {
    //审核人
    getChecks() {
      this.http.get("User?type=2&all=1&is_checker=1&checker_module_id=3").then(
          (res) => {
            if (res.code == 0) {
              this.checkerOption = res.data.data;
            }
          });
    },
    //搜索
    search() {
      this.listQuery.page = 1;
      this.getData();
    },
    async open() {
      if (this.dialogType === 'add') {
        this.resetData();
      } else if (this.dialogType === 'edit' || this.dialogType === 'detail') {
        this.getDetail();
      }
    },
    async getDetail() {
      try {
        const res = await this.http.get(
            `${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/get?id=${this.queryId}`
        );
        console.log(res, 'res');
        if (res.code === 0) {
          this.ruleForm = res.data;
          this.successCaseLogoSrc = res.data.successCaseLogoSrc
              ? JSON.parse(res.data.successCaseLogoSrc)
              : [];
          this.realImageSrc = res.data.realImageSrc ? JSON.parse(res.data.realImageSrc) : [];
          this.logoSrc = res.data.logoSrc ? JSON.parse(res.data.logoSrc) : [];
        } else {
          this.resetData();
        }
      } catch (e) {
        console.log(e);
      }
    },
    getData() {
      if(this.listQuery.time.length>0){
        this.listQuery.startTime = this.listQuery.time[0]
        this.listQuery.endTime = this.listQuery.time[1]
      }else {
        this.listQuery.startTime = ''
        this.listQuery.endTime = ""
      }
      this.http.post(
          this.urlConfig.devUrl + 'apij2/admin-api/system/problem-gather/page', this.listQuery).then(res => {
                if (res.code === 0) {
                  let arr = res.data.data;
                  arr.forEach(item => {
                    if (item.imgUrl) {
                      item.imgUrl = JSON.parse(item.imgUrl)
                      item.imgUrl = item.imgUrl.map( itemUrl => {
                        return {
                          url:this.imgUrl + itemUrl
                        }
                      })
                      console.log(item.imgUrl,'item.imgUrl')
                    } else {
                      item.imgUrl = [];
                    }
                  });
                  this.tableData = arr;
                  this.total = res.data.total;
                }
          });
    },
    //选择页码
    handleCurrentChange(e) {
      this.listQuery.page = e;
      this.getData();
    },
    // 获取数据字典
    getGroup(row) {
      let obj = {
        dictTypes: ['financial_institution_category', 'financial_investment_stage']
      };
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, obj).then(
          response => {
            if (response.code == 0) {
              console.log('response', response);
              this.orgTypeList = response.data.financial_institution_category;
              this.investmentList = response.data.financial_investment_stage;
              // this.ruleForm = response.data
            } else {
              this.$message.error(response.status);
            }
          },
          error => {}
      );
    },
    checkLimit(filelist, index) {
      const limit = this.limit;
      console.log(this.$refs['upload' + index]);
      const uploadDom = this.$refs['upload' + index];
      if (filelist.length === limit) {
        uploadDom.$children[1].$el.style.display = 'none';
        this['showUpload' + (index + 1)] = true;
      } else {
        uploadDom.$children[1].$el.style.display = '';
        this['showUpload' + (index + 1)] = false;
      }
    },
    selectChange(e, list, props) {
      if (e) {
        this.ruleForm[props] = list.find(item => item.id === e).label;
      } else {
        this.ruleForm[props] = '';
      }
      console.log('this.ruleForm[props]', this.ruleForm[props]);
    },
    // 修改按钮操作
    editOperate() {
      if((this.ruleForm.status === 1 ) && (!this.ruleForm.handler)){
        this.$message.error('请选择问题解决人');
        return
      }
      this.updateData()
    },
    updateData() {
      let _data = {...this.ruleForm}
      let _imgUrl = []
      if(_data.imgUrl.length > 0){
        _imgUrl = _data.imgUrl.map(urlItem =>{
          return urlItem.url.slice(this.imgUrl.length)
        })
      }
      _data.imgUrl = JSON.stringify(_imgUrl)
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/problem-gather/update`, {
            ..._data,
          })
          .then(res => {
            if (res.code === 0) {
              this.$message.success('修改成功');
              this.dialogFormVisible = false;
              this.getData();
            } else {
              this.$message.error(res.status);
            }
          })
          .catch(err => {
            this.dialogFormVisible = false;
          });
    },
    searchSelect() {
      this.listQuery.page = 1
      this.getData();
      // if (e) {
      //   this.listQuery.approvalStatus = e;
      //   this.getData();
      // } else {
      //   this.$delete(this.listQuery, 'approvalStatus');
      //   this.getData();
      // }
    },
    resetData() {
      this.ruleForm = {
        approvalStatus: 1,
        problemBelongs:'', // 问题所属模块
        imgUrl:[], // 图片地址
        descriptionProblem:'', // 问题描述
        phone:'', // 联系方式
        status:'', // 问题状态 0未处理 1已处理
        handler:'', // 处理人
        creator:'', // 创建人
        createTime:'', //创建时间/发布时间
        updater:'', //修改人
        updateTime:'', //修改时间
        deleted:'', //是否删除；非1 已删除',
      };
    },

    //城市选择
    citySelected(e) {
      if (e.province.value) {
        this.ruleForm.orgProvince = e.province.value;
      }
      if (e.city.value) {
        this.ruleForm.orgCity = e.city.value;
      }
      if (e.area.value) {
        this.ruleForm.orgDistrict = e.area.value;
      }
    },
    deleteImg(type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
          .then(() => {
            this.fileListChange(type, []);
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = '编辑';
      this.dialogType = 'edit';
      this.queryId = row.id;
      this.formApprovalStatus = row.approvalStatus;
      this.ruleForm = row
    },
    handleDetail(index, row) {
      this.dialogFormVisible = true;
      this.Title = '编辑';
      this.dialogType = 'detail';
      this.queryId = row.id;
      this.formApprovalStatus = row.approvalStatus;
    },
    addDataNew() {
      this.dialogFormVisible = true;
      this.Title = '新增';
      this.dialogType = 'add';
      this.logoSrc = [];
      this.realImageSrc = [];
      this.successCaseLogoSrc = [];
    },
    handleDelete(row) {
      this.$confirm('此操作将删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
          .then(() => {
            this.http
                .request(
                    this.urlConfig.devUrl +
                    '/apij2/admin-api/finance/investment-firms/delete?id=' + row.id,
                    '',
                    'delete'
                )
                .then(res => {
                  if (res.code == 0) {
                    this.listQuery.page = 1;
                    this.getData();
                    this.$message({
                      type: 'success',
                      message: '删除成功'
                    });
                  } else {
                    this.$message({
                      message: '失败！',
                      type: 'error'
                    });
                  }
                });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
    },
    // 确认添加机构
    createSite() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/finance/investment-firms/create`, {
                ...this.ruleForm,
                dataType: 2
              })
              .then(res => {
                if (res.code == 0) {
                  this.$message.success('新增成功');
                  this.dialogFormVisible = false;
                  this.resetData();
                  this.getData();
                } else {
                  this.$message.error(res.status);
                }
              })
              .catch(err => {
                this.dialogFormVisible = false;
              });
        } else {
          this.is_edit = true;

          console.log('error submit!!');
          return false;
        }
      });
    },
    handleRemove(file, type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
          .then(() => {
            for (var i = 0; i < this[type].length; i++) {
              if (file.uid == this[type][i].uid) {
                this[type].splice(i, 1);
              }
            }
            console.log(this[type]);
            this.fileListChange(type);

            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this[type] = fileList;
        console.log(this.ruleForm.logoSrc);
        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name
          });
        });
        this.ruleForm[type] = JSON.stringify(arr);

        // if (type === 'logoSrc' || type === 'realImageSrc') {
        //   this.ruleForm[type] = arr[0].url;
        // }
      } else {
        this.ruleForm[type] = '';
        this[type] = [];
      }
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
          file.type === 'image/jpeg' ||
          file.type === 'image/png' ||
          file.type === 'image/jpg' ||
          file.type === 'image/gif' ||
          file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    }
  }
};
</script>
<style lang="scss">
@include component(site) {
  width: 100%;
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }
  }

  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.el-input--suffix {
      width: 100%;
      margin: 0 15px;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }

  .el-select {
    width: 100%;
    margin: 0;
  }

  @include part(form) {
    margin: 30px auto;
    width: 50%;
  }

  @include component(rowItem) {
    width: 50%;
  }

  @include component(el-radio-group) {
    width: 100%;
    text-align: left;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .preview_btn {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(#000, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      cursor: pointer;
      font-size: 26px;
    }
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 130px;
    line-height: 130px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    display: flex;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }
  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .el-radio {
    display: flex;
    align-items: center;
  }

  .imgInput {
    background: url(../../../assets/add.png) no-repeat;
    border: none;
    text-indent: -2000px;
    height: 120px;
    padding: 10px;
    background-size: 70%;
    background-position: center;
    color: white;
    cursor: pointer;
  }

  .imgInput:focus {
    border: none;
    outline: 0;
  }

  .allPics {
    border: 1px solid #ccc;
    padding: 18px 15px 10px 20px;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 30px;
    position: relative;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
  }

  .allPics1 {
    display: flex;
    // flex-wrap: wrap;
  }

  .addPic-body {
    padding: 10px;
    height: 120px;
  }

  .addPic-close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .addPic {
    max-width: 100%;
    max-height: 100%;
  }

  .el-form-item__content {
    text-align: left;
  }

  .form-title {
    width: 100%;
    text-align: left;
    color: #623aa2;
    border-left: 5px solid #623aa2;
    border-bottom: 1px solid #623aa2;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }

  .rowItem1 {
    float: left;
  }
}
.overflow-hidde{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display:-webkit-box;
  　-webkit-box-orient:vertical; //子元素应该被水平或垂直排列
  　-webkit-line-clamp:1; //3行后显示省略号
}
</style>
